import { TabEmployeeApproveTabs } from '@pages/approval-employee-page/config/ui-constants';
import { useUrlTabs } from '@shared/lib/hooks/use-url-tabs/use-url-tabs';
import { SegmentTab } from '@shared/ui/segment-tabs/types';
import { useMemo } from 'react';

export const useTabs = ({
    orderCount,
    requestCount,
}: {
    orderCount: number | undefined;
    requestCount: number | undefined;
}) => {
    const { tabValue, handleSetTabValue } = useUrlTabs({
        tabValues: Object.values(TabEmployeeApproveTabs),
        initialTabValue: TabEmployeeApproveTabs.Orders,
    });

    const tabs: SegmentTab[] = useMemo(() => {
        const orderTab: SegmentTab = {
            title: 'Мои сделки',
            value: TabEmployeeApproveTabs.Orders,
        };

        const requestTab: SegmentTab = {
            title: 'Мои запросы',
            value: TabEmployeeApproveTabs.Requests,
        };

        if (orderCount) {
            orderTab.badge = {
                text: String(orderCount),
            };
        }

        if (requestCount) {
            requestTab.badge = {
                text: String(requestCount),
            };
        }
        return [orderTab, requestTab];
    }, [orderCount, requestCount]);

    return {
        tabValue,
        tabs,
        handleSetTabValue,
    };
};
